"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNegativeDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var isNegativeDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createIsNegative: _factoriesAny.createIsNegative
};
exports.isNegativeDependencies = isNegativeDependencies;